<template>
  <div class="aboutUs">
    <div class="content">
      <img
        src="../assets/about-us.png"
        class="img-fluid"
        alt="Responsive image"
      >
      <div class="content-detail">
        <h1
          data-delighter
          class="left"
        >我们专注于智能打印领域</h1>
        <h1
          data-delighter
          class="right"
        >领先的云服务</h1>
      </div>
    </div>

    <div class="container">
      <div class="row content-title">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>了解印点点</h1>
          <ul class="about">
            <li>深圳市印点点科技有限公司成立于2015年，总部位于深圳，是一家互联网科技企业。</li>
            <li>作为智能打印领域领先的云服务提供商，印点点自助打印平台有图文快印（QQ/微信扫码付费打印）、共享打印（手机自助打印、远程打印）、企业办公（钉钉/企业微信扫码打印）三大产品形态，分别面向C端、2B2C端以及B端市场提供一站式自助打印解决方案，覆盖各个场景的智能打印需求。</li>
            <li>印点点拥有出色的软硬件设计能力、供应链渠道整合能力、数据价值开发能力以及高标准服务意识，正在引领文印行业互联网+，推动文印行业智能变革。</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container margin-bottom">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <h1 class="info-title">深圳市印点点科技有限公司</h1>
          <ul class="info">
            <li>服务热线：400-805-6601 </li>
            <li>Email：ydd@yindd.cn</li>
            <li>业务主网站：http://www.yindd.cn/</li>
            <li>公司地址：深圳市南山区桃源街道平山社区珠光北路88号明亮科技园1栋302</li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <img
            src="../assets/map.png"
            class="img-fluid"
            alt="Responsive image"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="stylus" scoped>
.content-detail {
  text-align: center;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-30%);

  h1 {
    font-size: 3.2rem;
    font-weight: 100 !important;
    line-height: 2rem;
    color: #fff;
  }
}

.content-title {
  text-align: center;
  padding: 60px 0 70px;

  h1 {
    color: #18182a;
    font-weight: normal;
    font-stretch: normal;
    font-size: 40px;
  }
}

.about {
  text-align: left;
  list-style: none;
}

.about li, .info li {
  margin-bottom: 20px;
  font-size: 18px;
  color: #555;
}

.about li:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 15px;
  background-color: #3e7fec;
  border-radius: 5px;
}

.info-title {
  font-size: 30px;
  color: #18182a;
  margin-top: 55px;
}

.margin-bottom {
  margin-bottom: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue